import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';
import PerfectScrollbar from 'perfect-scrollbar';
import { Agent } from '../../models/agent.model';
import { AgentProfileService } from '../../services/agent-profile.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
  styleUrls: ['./side-bar-side.component.scss'],
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
  private sidebarPS: PerfectScrollbar;
  public menuItems: any[];
  public hasIconTypeMenuItem: boolean;
  public iconTypeMenuTitle: string;
  public agentInfo: Agent;
  public profileLink: string = '';
  public agentSubscriptionData: any;
  public environmentBaseUrl = environment.urlDomain;
  public agentAgencies;
  private menuItemsSub: Subscription;
  private agentPlanReadySub: Subscription;
  private agentAgencyReadySub: Subscription;
  private agentInfoSub: Subscription;

  constructor(
    private navService: NavigationService,
    public themeService: ThemeService,
    private agentInfoService: AgentProfileService,
  ) {
    // this.agentInfoService.getAgent().subscribe(data => {
    //   this.agentInfo = new Agent(data);
    //   this.agentInfoService.addAgentData(this.agentInfo);
    // });
    this.agentPlanReadySub = this.agentInfoService.agentSubsciptionFetched.subscribe(
      data => {
        this.agentSubscriptionData = data.results[0].plan;
      },
    );
    this.agentAgencyReadySub = this.agentInfoService.agentAgencyFetched.subscribe(
      val => {
        this.agentAgencies = val;
      },
    );
  }

  ngOnInit() {
    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      this.menuItems = menuItem;
      //Checks item list has any icon type.
      this.hasIconTypeMenuItem = !!this.menuItems.filter(
        item => item.type === 'icon',
      ).length;
    });
    if (window.location.hostname == 'agent.mashvisor.com') {
      this.profileLink = 'https://www.mashvisor.com/explore/#!/profile/';
    } else {
      this.profileLink = 'https://build.mashvisor.com/explore/#!/profile/';
    }
    if (this.agentInfoService.readyAgent) {
      this.agentInfo = this.agentInfoService.readyAgent;
    } else {
      this.agentInfoSub = this.agentInfoService.agentFetched.subscribe(val => {
        this.agentInfo = val;
      });
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.sidebarPS = new PerfectScrollbar('#scroll-area', {
        suppressScrollX: true,
      });
    });
  }
  ngOnDestroy() {
    if (this.sidebarPS) {
      this.sidebarPS.destroy();
    }
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }
    if (this.agentPlanReadySub) {
      this.agentPlanReadySub.unsubscribe();
    }
    if (this.agentAgencyReadySub) {
      this.agentAgencyReadySub.unsubscribe();
    }
    if (this.agentInfoSub) {
      this.agentInfoSub.unsubscribe();
    }
  }

  signOut() {
    this.agentInfoService.signOut();
    window.location.pathname = '';
  }

  goToHomePage() {
    window.location.href = this.environmentBaseUrl;
  }
}
